import React from 'react';
import './Header.css'; // Import the CSS file
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

const menuItems = [
    {
      title: 'Project',
      submenu: [
        { title: 'Description', link: 'description' },
        { title: 'Design', link: 'design' },
        { title: 'Proof of Concept', link: 'proof-of-concept' },
        { title: 'Engineering', link: 'engineering' },
        { title: 'Contributions', link: 'contributions' },
      ],
    },
    {
      title: 'Human practices',
      submenu: [
        { title: 'Integrated human practices', link: 'human-practices' },
        { title: 'Design principles from HP', link: 'human-practices#design-principles-from-hp' },
        { title: 'Outreach & Education', link: 'outreach' },
      ],
    },
    {
      title: 'Model',
      submenu: [
          { title: 'Mathematical Model', link: 'model#mathematical' },
          { title: 'AI-assisted binder design', link: 'model#silico' }, 
      ],
    },

    {
      title: 'Lab',
      submenu: [
        { title: 'Protocols', link: 'protocols' },
        { title: 'Safety', link: 'safety' },
        { title: 'Parts', link: 'parts' },
        { title: 'Results', link: 'results' },

      ],
    },


      {
        title: 'Entrepreneurship',
        submenu: [
          { title: 'Overview', link: 'entrepreneurship' },
          { title: 'Executive Summary', link: 'entrepreneurship#executive-summary', indented: true },
          { title: 'Innovativeness and Uses', link: 'entrepreneurship#innovativeness-uses', indented: true  },
          { title: 'Product design', link: 'entrepreneurship#product-design', indented: true  },
          { title: 'Industry and Market research', link: 'entrepreneurship#market-research', indented: true  },
          { title: 'Business Plan', link: 'entrepreneurship#business-plan', indented: true  },
          { title: 'Financials', link: 'entrepreneurship#financials', indented: true  },
          { title: 'References', link: 'entrepreneurship#references', indented: true  },

        ],
      },
      {
        title: 'Team',
        submenu: [
          { title: 'Attributions', link: 'attributions' },
          { title: 'Team members', link: 'team' },
          { title: 'Sponsors', link: 'sponsors' },
        ],
      },
      {
        title: 'Competition',
        submenu: [
          { title: 'Competition', link: 'competition' },
          { title: 'Medal criteria', link: 'medal-criteria' },
        ],
      },

  ];
  
  function MyNavMenu() {
  
    return (
      <Navbar expand="lg"  fixed="top"  className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/paris-bettencourt">Lubritect</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/paris-bettencourt">Home</Nav.Link>
            { menuItems.map((data, index) => (
              <NavDropdown title={data.title} id="basic-nav-dropdown">
                  { data.submenu.map((subtitle, index) => (
                    <NavDropdown.Item 
                        href={"/paris-bettencourt/" + subtitle.link} 
                        className={subtitle.indented ? 'nav-dropdown-indent' : ''}>
                      {subtitle.title}
                    </NavDropdown.Item>
                ))}

              </NavDropdown>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    );
  }
  
  
function Header() {
  return (
    <div>
      <MyNavMenu/>
      <img className='banner' src='https://static.igem.wiki/teams/4602/wiki/images/images/header.png' alt='banner'></img>
    </div>
  );
}

export default Header;
